import { Filter } from '@urc-ui/store/api/types';
import { REPORT_CATEGORY } from '@urc-ui/utils/types';

export const enum COLUMN_QUERY_NAME {
  SUBSCRIPTION_NAME = 'SUBSCRIPTION_NAME',
  SUBSCRIPTION_STATUS = 'SUBSCRIPTION_STATUS',
  SUBSCRIPTION_SCOPE = 'SUBSCRIPTION_SCOPE'
}
export const enum FILTER_TYPE {
  BROADMATCH = 'BROADMATCH_CASE_INSENSITIVE',
  EXACTMATCH = 'EXACTMATCH',
  INCLUDE = 'INCLUDE'
}

const generateCategoryFilterValues = (values: string[]) => {
  const convertedValues: string[] = [];
  values.forEach(value => {
    convertedValues.push('{"ProgramType":"' + value + '"}');
  });
  return convertedValues;
};

export const getSubscriptionNameFilter = (subscriptionName: string): Filter => {
  return {
    column_name: COLUMN_QUERY_NAME.SUBSCRIPTION_NAME,
    filter_type: FILTER_TYPE.BROADMATCH,
    values: [subscriptionName]
  };
};

export const getStatusColumnFilter = (values: string[]): Filter => {
  return {
    column_name: COLUMN_QUERY_NAME.SUBSCRIPTION_STATUS,
    filter_type: FILTER_TYPE.EXACTMATCH,
    values: values
  };
};

export const getCategoryColumnFilter = (values: string[]): Filter => {
  const includedCategories: string[] = [];
  values.forEach(category => {
    if (category === REPORT_CATEGORY.HSA) {
      includedCategories.push(category);
      includedCategories.push(REPORT_CATEGORY.SB);
      includedCategories.push(REPORT_CATEGORY.SBV);
    } else if (category === REPORT_CATEGORY.SD) {
      includedCategories.push(category);
      includedCategories.push(REPORT_CATEGORY.PDA);
    } else {
      includedCategories.push(category);
    }
  });

  return {
    column_name: COLUMN_QUERY_NAME.SUBSCRIPTION_SCOPE,
    filter_type: FILTER_TYPE.INCLUDE,
    values: generateCategoryFilterValues(includedCategories)
  };
};
